import React from 'react';
import SVG from '@newrelic/gatsby-theme-newrelic/src/components/SVG';

const JMXIcon = (props) => {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <g fill="none" fillRule="evenodd">
        <path
          d="M12.363 23.1s-1.018.576.723.771c2.11.235 3.188.201 5.512-.228 0 0 .612.374 1.465.697-5.21 2.178-11.793-.126-7.7-1.24M11.726 20.258s-1.141.823.601.999c2.254.226 4.033.245 7.112-.333 0 0 .426.42 1.096.651-6.3 1.796-13.318.142-8.81-1.317"
          fill="#5382A1"
        />
        <path
          d="M17.094 15.438c1.284 1.44-.338 2.738-.338 2.738s3.26-1.641 1.763-3.696c-1.398-1.916-2.47-2.868 3.335-6.151 0 0-9.113 2.219-4.76 7.109"
          fill="#E76F00"
        />
        <path
          d="M23.986 25.2s.752.606-.83 1.073c-3.007.889-12.518 1.157-15.16.036-.95-.403.831-.962 1.391-1.08.585-.123.918-.1.918-.1-1.056-.725-6.827 1.425-2.93 2.04 10.624 1.68 19.367-.756 16.61-1.968M12.852 17.314s-4.838 1.12-1.714 1.527c1.32.172 3.95.133 6.4-.067 2.002-.165 4.012-.515 4.012-.515s-.706.295-1.216.635c-4.913 1.26-14.404.674-11.672-.615 2.311-1.089 4.19-.965 4.19-.965M21.53 22.043c4.994-2.53 2.685-4.962 1.074-4.634-.395.08-.571.15-.571.15s.146-.224.426-.321c3.189-1.093 5.64 3.223-1.029 4.933 0 0 .077-.067.1-.128"
          fill="#5382A1"
        />
        <path
          d="M18.52 3.028s2.765 2.697-2.624 6.846c-4.321 3.327-.985 5.224-.002 7.392-2.522-2.219-4.373-4.172-3.131-5.99 1.822-2.67 6.872-3.963 5.756-8.248"
          fill="#E76F00"
        />
        <path
          d="M13.342 28.9c4.794.299 12.156-.166 12.33-2.378 0 0-.335.839-3.962 1.504-4.091.751-9.138.663-12.13.182 0 0 .612.495 3.762.692"
          fill="#5382A1"
        />
      </g>
    </SVG>
  );
};

export default JMXIcon;
